import React from 'react';
import T from 'prop-types';
import { connect } from 'react-redux';
import Features from 'app/features';
import history from 'app/history';
import {
  selectShowFeatureFlags,
  selectShowFeatureFlagsStatus,
  FEATURE_FLAG_LOADED_STATUS,
} from 'ducks/feature-flags';

class ShowSettingsAccessFeatureGuard extends React.Component {
  static propTypes = {
    children: T.node,
    didCheckShowFeatures: T.bool.isRequired,
    hasAcastAccessFeature: T.bool.isRequired,
    showId: T.string.isRequired,
  };

  static defaultProps = {
    children: undefined,
  };

  componentDidMount() {
    this.redirectUnlessFeatureEnabled();
  }

  componentDidUpdate() {
    this.redirectUnlessFeatureEnabled();
  }

  redirectUnlessFeatureEnabled = () => {
    const { didCheckShowFeatures, hasAcastAccessFeature, showId } = this.props;

    if (didCheckShowFeatures && !hasAcastAccessFeature) {
      history.get().replace(`/shows/${showId}/settings`);
    }
  };

  render() {
    const { children, didCheckShowFeatures, hasAcastAccessFeature } = this.props;

    if (!didCheckShowFeatures || !hasAcastAccessFeature) {
      return null;
    }

    return children;
  }
}

export default connect((state, { showId }) => {
  const featureFlags = selectShowFeatureFlags(showId)(state);
  const featureFlagsStatus = selectShowFeatureFlagsStatus(showId)(state);

  return {
    didCheckShowFeatures: featureFlagsStatus === FEATURE_FLAG_LOADED_STATUS,
    hasAcastAccessFeature: featureFlags.includes(Features.AcastAccess),
  };
})(ShowSettingsAccessFeatureGuard);
